// Once base properties are known, we can add them here
// tslint:disable-next-line:no-empty-interface
interface BaseNotification {
  projectId: string;
  openExceptions: boolean;
}

// Add new types based on different notifications
export enum NotificationType {
  VA_TIMECARD_STATUS_UPDATE = 'VA_TIMECARD_STATUS_UPDATE',
  VA_BATCH_STATUS_UPDATE = 'VA_BATCH_STATUS_UPDATE',
}

export interface VaTimecardStatus extends BaseNotification {
  timecardId: string;
}

export interface VaBatchStatus extends BaseNotification {
  batchId: string;
}

// Add more notifications as needed
export type Notifications = VaTimecardStatus | VaBatchStatus;
